import angular from 'angular';
import '../../../services/cart';
import '../../../directives/register-form';

angular.module('folkeuni').component('discounts', {
  bindings: {
    cart: '=',
    state: '<'
  },
  controller: function (Cart, $location, $window, $scope, $rootScope) {
    var $ctrl = this;
    $ctrl.students = [];

    function getMaxStudentDiscounts() {
      if (!$ctrl.cart || !$ctrl.cart.products) return 0;
      var max = 0;
      $ctrl.cart.products.forEach(function(product) {
        if (product.discount && Array.isArray(product.discount)) {
          var count = product.discount.filter(function(d) { return d.type === 'Student'; }).length;
          if (count > max) max = count;
        }
      });
      return max;
    }

    $ctrl.initStudents = function() {
      var max = getMaxStudentDiscounts();
      var newStudents = [];
      for (var i = 0; i < max; i++) {
        if ($ctrl.cart && $ctrl.cart.checkout && Array.isArray($ctrl.cart.checkout.students)) {
          var student = $ctrl.cart.checkout.students[i];
          newStudents.push({
            place: student && typeof student.place === 'string' ? student.place : '',
            number: student && typeof student.number === 'string' ? student.number : ''
          });
        } else {
          newStudents.push({ place: '', number: '' });
        }
      }
      $ctrl.students = newStudents;
    };

    $ctrl.checkForDuplicates = function() {
      var valid = true;
      var seen = {};
      $ctrl.students.forEach(function(student) {
        var place = (student.place || '').trim();
        var number = (student.number || '').trim();
        if (place.length < 2 || number.length < 1) {
          student.invalid = false;
          return;
        }
        var key = place.toLowerCase() + '|' + number.toLowerCase();
        if (seen[key]) {
          student.invalid = true;
          valid = false;
        } else {
          student.invalid = false;
          seen[key] = true;
        }
      });
      return valid;
    };

    $ctrl.syncStudentsToDiscounts = function() {
      if (!$ctrl.cart.checkout) $ctrl.cart.checkout = {};
      $ctrl.cart.checkout.students = $ctrl.students.map(function(student) {
        return {
          place: student && student.place != null ? student.place : '',
          number: student && student.number != null ? student.number : ''
        };
      });
      console.dir($ctrl.cart.checkout.students);
    };

    var discountsChangedTimeout;
    $ctrl.discountsChanged = function() {
      if (discountsChangedTimeout) {
        clearTimeout(discountsChangedTimeout);
      }
      discountsChangedTimeout = setTimeout(function() {
        $ctrl.syncStudentsToDiscounts();
        Cart.customerInfoLocalStorageSet($ctrl.cart);
      }, 400);
    };

    $ctrl.$onInit = function() {
      $ctrl.initStudents();
      $ctrl.checkForDuplicates();
      if ($scope.$parent && $scope.$parent.$ctrl && $scope.$parent.$ctrl.registerValidityChecker) {
        $scope.$parent.$ctrl.registerValidityChecker($ctrl.isValid);
      }
      $rootScope.$on('cart.update', function(evt, cart) {
        $ctrl.cart = cart;
        $ctrl.initStudents();
        $ctrl.checkForDuplicates();
      });
    };
    $ctrl.isValid = function() {
      var allValid = true;
      if ($ctrl.students && $ctrl.students.length) {
        for (var i = 0; i < $ctrl.students.length; i++) {
          var s = $ctrl.students[i];
          if (!s.place || s.place.length < 2 || !s.number || s.number.length < 1 || s.invalid) {
            allValid = false;
            break;
          }
        }
      }
      return allValid && $ctrl.checkForDuplicates();
    };

    $scope.studentForms = {};
    $scope.registerForm = function(index, form) {
      $scope.studentForms[index] = form;
    };

    $scope.$on('checkout:showAllErrors', function() {
      angular.forEach($scope.studentForms, function(form) {
        if (form) {
          angular.forEach(form, function(field) {
            if (field && field.$setTouched) field.$setTouched();
            if (field && field.$validate) field.$validate();
          });
        }
      });
    });
  },

  templateUrl: '/shop-dist/templates/discounts.html?c=' + window.cacheBurst,
  transclude: true
});